export default "__VITE_ASSET__WN9$Yk3o__"